<template>
  <!-- BEGIN: Top Bar -->
  <div class="top-bar">
    <!-- BEGIN: Breadcrumb -->
    <div class="-intro-x breadcrumb mr-auto hidden sm:flex">
      <el-button type='primary'  @click="toBigData" v-if="user.adminFlag&&user.bigDataCenterFlag&&$route.path=='/workBench/workbench'">进入国有资产数字化大数据中心 <i class="el-icon-arrow-right"></i></el-button>
    </div>
    <!-- END: Breadcrumb -->
    <!-- BEGIN: Notifications -->
    <div class="intro-x relative mr-auto sm:mr-6">
      <div
        :class="untreated ? 'notification notification--bullet cursor-pointer':'notification cursor-pointer'"
        @click='$router.push("/workBench/workbench")'
      >
        <BellIcon class="notification__icon dark:text-gray-300" />
      </div>
    </div>
    <!-- END: Notifications -->
    <!-- BEGIN: Account Menu -->
    <div class="intro-x dropdown w-8 h-8 relative">
      <div
        class="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
      >
        <img
          alt="Midone Tailwind HTML Admin Template"
          :src="user.imgUrl"
        />
      </div>
      <div class="dropdown-box mt-10 absolute w-56 top-0 right-0 z-20">
        <div
          class="dropdown-box__content box bg-theme-38 dark:bg-dark-6 text-white"
        >
          <div class="p-4 border-b border-theme-40 dark:border-dark-3">
            <div class="font-medium">{{user.name }}</div>
            <div class="text-xs text-theme-41 dark:text-gray-600">
              {{ user.companyName}}
            </div>
          </div>
          <div class="p-2 border-t border-theme-40 dark:border-dark-3">
            <a
              href='javascript:;'
              @click='logout'
              class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
            >
              <ToggleRightIcon class="w-4 h-4 mr-2" />
              退出登录
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Account Menu -->
  </div>
  <!-- END: Top Bar -->
</template>

<script>
import {mapState} from 'vuex'
import {logout} from "@/api/account";
import {delAllCookie} from "@/assets/js/tools";

export default {
  data() {
    return {
      searchDropdown: false
    };
  },
  methods: {
    toBigData(){
      let routeData = this.$router.resolve({ path: '/bigData'});
      window.open(routeData.href, '_blank');
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    logout(){
      logout({}).then(res => {
        let data = res.data
        if (data.code === '000') {
          delAllCookie()
          this.$router.push('/login')
        } else {

        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {

      })
    },
  },
  computed: {
    ...mapState({
      user:state=>state.user.user,
      untreated:state=>state.work.untreated
    })
  },
  created() {
    
  }
};
</script>
